import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import HeroSection from './heroSection/HeroSection';
import StartProjectSection from './startProjectSection/StartProjectSection';
import ViewDocSection from './viewDocSection/ViewDocSection';
import OmniStartDevSection from './omniStartDevSection/OmniStartDevSection';
import DownloadSdkSection from './downloadSdkSection/DownloadSdkSection';
import AppFooter from '../../components/AppLayout/AppFooter/AppFooter';

export default function GetStartedPage() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<section data-testid={"landing-page"}>
				<HeroSection />
			</section>
			<section>
				<StartProjectSection />
			</section>
			<section>
				<ViewDocSection />
			</section>
			<section>
				<OmniStartDevSection />
			</section>
			<section>
				<DownloadSdkSection />
			</section>
			<section>
				<AppFooter />
			</section>
		</>
	);
}
